<template>
  <v-dialog
    v-model="showModal"
    content-class="event-modal forms__event"
    :persistent="!dismissible"
  >
    <v-card class="event-modal__wrap ra ">
      <div class="ra__form-heading ">
        <v-card-title class="ra__modal-title">
          <h3 class="ra__modal-title--heading">{{ modalTitle }}</h3>
        </v-card-title>
        <ra-modal-close-button v-if="dismissible" @close-modal="onCloseModal" />
      </div>
      <v-card-text class="ra__modal-body">
        <div v-html="modalBody">
        </div>
      </v-card-text>
      <v-card-actions class="ra__action-btn pb-4">
        <v-spacer></v-spacer>
          <v-btn
            depressed
            large
            class="btn-primary"
            @click="buttonAction"
            v-if="isNotDashboard"
          >
            {{ buttonText }}
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RaModalCloseButton from '~/components/general/RaModalCloseButton'

export default {
  name: 'RaAccountRestrictModal',
  components: { RaModalCloseButton },
  data () {
    return {
      dialog: false,
      payload: {}
    }
  },
  computed: {
    dismissible () {
      return !!this.payload.dismissible
    },
    modalTitle () {
      return this.payload.title ? this.$t(this.payload.title) : this.$t('account_restricted.title')
    },
    modalBody () {
      return this.payload.content ? this.$t(this.payload.content) : this.$t('account_restricted.content')
    },
    buttonText (){
      return this.payload.button_text ? this.$t(this.payload.button_text) : this.$t('account_restricted.make_payment')
    },
    showModal () {
      return this.dialog
    },
    isNotDashboard(){
      return this.$router.currentRoute.name !== 'dashboard' || this.payload.redirect_url !== 'dashboard'
    }
  },
  methods: {
    onCloseModal () {
      this.dialog = false
    },
    async buttonAction() {
      await this.$store.dispatch('permission/resume')
      await this.$router.push({name: this.payload.redirect_url})
    }
  },
  created () {
    this.$nextTick(()=> {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'permission/SHOW_ACCOUNT_RESTRICT_POPUP') {
          this.payload = state.permission.payload
          this.dialog = true
        }
      })
      if(sessionStorage.authorization && JSON.parse(sessionStorage.authorization).account_is_restricted && this.$router.currentRoute.name != 'dashboard'){
        this.$store.dispatch('permission/showAccountRestrictPopup', { user: JSON.parse(sessionStorage.authorization).role, route: this.$router.currentRoute.name })
      }
    })

    // Close the Modal if found the valid user and event
    this.$root.$on('close-account-restrict-modal', () => {
      this.onCloseModal()
    })
  }
}

</script>

<style scoped>
.font-p{font-size: medium;}
.font-who{font-size: large;font-weight: bold;}
.font-data{color: var(--ra-color-grey1) !important;}
</style>
